<template>
    <!--页脚导航-->
    <div class="contact_box">
        <div class="web_content">
          <div class="footer_contact">
              <div class="footer_logo">
                <img src="../../../assets/img/jjhlogo.png">
              </div>
              <div class="address">
                <div>
                  <i class="iconfont icon-web-youxiang1"></i><span>邮箱：ks_jjh@kingsoft.com</span>
                </div>
                <div>
                  <i class="iconfont icon-web-dizhi"></i><span>地址：北京市海淀区西二旗中路33号小米科技园D栋</span>
                </div>
              </div>
          </div>
          <div class="record_div">
            <div class="copyright">copyright@2023 kingsoft，All Rights Reserved.</div>
            <div class="record">
              <div>
                <span @click="openPlice">京公网安备11010802025727（总）</span>
                <span @click="openNetAcc">网出证（京）字第168号</span>
                <span @click="openICP">京ICP备2025133571号</span>
              </div>
              <img @click="openAccept" src="../../../assets/img/kxlogo.png">
            </div>
            
          </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '../../../store'
export default {
  name: 'footerBuild',
  components:{},
  props: {
    
  },

  data () {
    return {
      
      dataInfo:store.getters.getNavigatorInfo,
    }
  },
  computed:{
    ...mapGetters([
        'getNavigatorInfo'
    ]),
  },
  methods:{
    openPlice(){
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025727")
    },
    openNetAcc(){
      
      window.open("netAcc")
    },
    openICP(){
      window.open("https://beian.miit.gov.cn/")
    },
    openAccept(){
      window.open("https://ss.knet.cn/verifyseal.dll?sn=e13111511010043456nq0k000000&ct=df&a=1&pa=0.028054921654984355",'_blank')
    },
    
  },
  watch:{
    
  },
  mounted(){
    
  }
}
</script>

<style lang="less"> 
    @import '../../../assets/css/ks_foundation.less';
    @import '../../../assets/css/ks_media.less';
    @import '../../../assets/fonts/iconfont.css';
    
</style>
